<template>
  <div class="footer">
    <div class="layout bgwhite">
      <div class="container">
        <!-- top -->
        <div class="top flex flex-y">
          <div class="flex flex-y" style="margin-right:100px">
            <img src="@/assets/images/footer/phone.png" class="icon" />
            <i class="line"></i>
            <span class="blue">0755-26400082</span>
          </div>
          <div class="flex flex-y">
            <img src="@/assets/images/footer/location.png" class="icon" />
            <i class="line"></i>
            <span class="address">广东省深圳市南山区兰光科技园A栋219</span>
          </div>
        </div>
        <!-- bottom -->
        <div class="bottom flex flex-between">
          <div class="left">
            <ul class="flex flex-y">
              <li>了解图小助</li>
              <li>问题反馈</li>
            </ul>
            <div class="copy">
              &copy; 2019 Tuxiaozhu Telecom Equipment Co., Ltd. All rights
              reserved.
              <a
                href="http://beian.miit.gov.cn/"
                target="_blank"
              >
                <span @click="goTo">粤ICP备18094620号-1</span>
              </a>
            </div>
          </div>
          <div class="right flex">
            <div class="flex qq">
              <img src="@/assets/images/footer/qq.png" class="icon" @click="qq()" height="20" />
              <img
                src="@/assets/images/footer/wx.png"
                @mouseover="showScan = true"
                @mouseout="showScan = false"
                height="22"
              />
              <!-- 弹出微信二维码 -->
              <transition name="fadeInDown">
                <div class="scan" v-show="showScan">
                  <img src="@/assets/images/footer/erweima.jpg" width="100" />
                </div>
              </transition>
            </div>
            <div class="erweima" @click="showBigScan">
              <img src="@/assets/images/footer/erweima.jpg" width="60" />
              <!-- <p>下载图小助APP</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="图小助公众号" :visible.sync="showBigScanBool" width="30%" center style="margin-top: 20vh;">
      <img src="@/assets/images/footer/erweima.jpg" style="margin: 0 auto;" />
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      showScan: false,
      showBigScanBool: false,
      scroll: false,
    };
  },
  computed: {
    ...mapState({
      getScroll: state => state.scrollBottom
    })
  },
  watch: {
    getScroll(val) {
      this.handleScrollBottom();
    }
  },
  methods: {
    qq: function() {
      let url = `tencent://message/?uin=754607626&Site=&Menu=yes`;
      window.open(url);
    },
    //点击弹出公众号二维码
    showBigScan() {
      this.showBigScanBool = true;
    },
    handleScrollBottom() {
      let h = document.body.scrollHeight;
      window.scrollTo({
        top: h,
        behavior: "smooth"
      });
      this.setScroll(this.scroll);
    },
    goTo() {
      window.open("http://beian.miit.gov.cn");
    },
    ...mapMutations(["setScroll"])
  }
};
</script>

<style lang="scss" scoped>
.footer {
  .layout {
    width: 100%;
    height: 216px;
    .container {
      width: 1100px;
      margin: 0 auto;
      //top
      .top {
        border-bottom: 1px solid #dedede;
        padding: 40px 0;
        .icon {
          height: 16px;
        }
        .line {
          margin: 0 10px;
          width: 1px;
          height: 16px;
          background-color: #e9e9eb;
        }
        span {
          font-size: 14px;
        }
      }
      //bottom
      .bottom {
        padding-top: 20px;
        .left {
          margin-top: 10px;
          ul {
            li {
              font-size: 13px;
              color: #7d7e8e;
              padding-right: 35px;
              border-right: 1px solid #7d7e8e;
              height: 14px;
              line-height: 14px;
              cursor: pointer;
            }
            li:nth-child(2) {
              padding-left: 37px;
            }
            li:hover {
              color: #6265ff;
            }
          }
          .copy {
            font-size: 13px;
            color: #7d7e8e;
            margin-top: 14px;
            display: flex;
            align-items: center;
            span {
              margin-left: 20px;
              cursor: pointer;
            }
          }
        }
        .right {
          .qq {
            position: relative;
            align-items: flex-end;
            margin-right: 50px;
            img {
              cursor: pointer;
              margin-left: 30px;
            }
            img:hover {
              opacity: 0.9;
            }
            .scan {
              position: absolute;
              right: -40px;
              bottom: 20px;
            }
          }
          .erweima {
            width: 120px;
            text-align: center;
            font-size: 11px;
            color: #7d7e8e;
            img {
              margin: 0 auto;
            }
            p {
              margin-top: 2px;
            }
          }
        }
      }
    }
  }
}
.blue {
  color: #6265ff;
  font-weight: bold;
}
.address {
  font-weight: 500;
}
//动画
.fadeInDown-enter-active {
  animation: fadeInDown-in 0.5s;
}
.fadeInDown-leave-active {
}
@keyframes fadeInDown-in {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -20%, 0); //30%移动幅度
    transform: translate3d(0, -20%, 0); //30%移动幅度
  }
  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
</style>
